import LoadingComponent from '@/pages/components/common/LoadingComponent'
import Loadable from 'react-loadable'
export default [
  {
    path: '/courierView/insurance/main',
    component: Loadable({
      loader: () => import('@/pages/insurance/main'),
      loading: LoadingComponent
    })
  },

  {
    component: Loadable({
      loader: () => import('@/pages/insurance/buyRecord/index'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/insurance/buyRecord',
    meta: {
      title: '自选保险记录'
    }
  },
  {
    component: Loadable({
      loader: () => import('@/pages/insurance/main/agreement'),
      loading: LoadingComponent
    }),
    exact: true,
    path: '/courierView/insurance/agreement',
    meta: {
      title: '闪送三者险理赔须知'
    }
  }
]
